import SearchableMultiSelectMenu from "@/app/components/ui/SelectMenus/MultiSelectMenu";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useStaffClinicListAPI } from "@/app/hooks/api_hooks/clinic/useStaffClinicListAPI";
import { useDayClosingCurrentShift } from "@/app/hooks/api_hooks/dayClosing/useDayClosingCurrentShift";
import { useOrgCitiesListAPI } from "@/app/hooks/api_hooks/org/useOrgCitiesListAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useFeatureAccess } from "@/app/hooks/useFeatureAccess";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";

const DayClosingFilterComponent = () => {
  const { mappedCityId, mappedClinicId } = useAppSelector((state) => state.root.UIStates);

  const { execute: fetchCurrentShift, closureData: shift } = useDayClosingCurrentShift();

  const navigate = useNavigate();

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      shift: "day",
      clinics: mappedClinicId,
    },
  });

  const { cities, clinics } = useRouteInfo("INVENTORY")?.routeState?.state as IInventoryState;

  const fetchCities = useOrgCitiesListAPI("INVENTORY");
  const fetchPWLClinics = useStaffClinicListAPI("INVENTORY");
  const cityOrgItem = useSelectMenuReducer(cities, "name", "id");
  const clinicsOrgItem = useSelectMenuReducer(clinics, "display_name", "id");

  useEffect(() => {
    fetchCities();
    const cities = formHook?.getValues("city");
    if (cities) {
      fetchPWLClinics({
        cityIds: [cities],
        withProviders: false,
      });
    }
  }, [formHook.watch("city")]);

  useEffect(() => {
    mappedClinicId && fetchCurrentShift(mappedClinicId);
  }, [mappedClinicId]);

  const onSubmit = () => {
    navigate(
      `/app/closing/day-closing?closing_process=p0&city_id=${formHook.watch("city") || mappedCityId}&clinic_ids=${formHook.watch("clinics") || mappedClinicId}&shift=${formHook.watch("shift")}&t=${Date.now()}`,
    );
  };

  useEffect(() => {
    navigate(
      `/app/closing/day-closing?closing_process=p0&city_id=${formHook.watch("city") || mappedCityId}&clinic_ids=${formHook.watch("clinics") || mappedClinicId}&shift=${formHook.watch("shift") || shift?.shift}&t=${Date.now()}`,
    );
  }, [formHook.watch("clinics")]);

  useEffect(() => {
    if ((mappedClinicId && mappedCityId && shift?.shift === "day") || shift?.shift === "night") {
      navigate(
        `/app/closing/day-closing?closing_process=p0&city_id=${mappedCityId}&clinic_ids=${mappedClinicId}&shift=${shift?.shift}&t=${Date.now()}`,
      );
      formHook.setValue("city", mappedCityId);
      formHook.setValue("clinics", mappedClinicId);
      formHook.setValue("shift", shift?.shift);
    }
  }, [mappedCityId, mappedClinicId, shift?.shift]);
  const isCentralOpps = useFeatureAccess("ACCOUNTING_CASH_CLOSING_CENTRAL_VIEW");

  return (
    <div className="w-full">
      {isCentralOpps && (
        <form
          className="w-full flex flex-col lg:flex-row items-stretch lg:items-center justify-end gap-2 lg:gap-3"
          onSubmit={formHook.handleSubmit(onSubmit)}
        >
          <div className="w-full lg:min-w-[170px] lg:max-w-[220px]">
            <SearchableSelectMenu
              onSelectItem={(item) => {
                formHook.setValue("city", item.id);
              }}
              errorMessages={[{ message: "Required", type: "required" }]}
              fieldError={formHook.formState.errors.city}
              register={formHook.register("city", { required: true })}
              className=""
              showTypedErrors={false}
              showDropdownIcon
              containerClassName=""
              placeholder="Select city"
              selectItems={cityOrgItem}
              defaultSelected={cityOrgItem?.filter((ci) => ci.id === formHook.watch("city"))[0]}
              autoComplete="false"
            />
          </div>
          <div className="w-full lg:min-w-[220px] lg:max-w-[360px]">
            <SearchableMultiSelectMenu
              withSelectAll
              errorMessages={[]}
              onSelectItem={(item) => {
                if (item) {
                  const clinicsId = item.map((i) => i.id);
                  formHook.setValue("clinics", clinicsId);
                }
              }}
              fieldError={formHook.formState.errors.clinics}
              register={formHook.register("clinics", { required: true })}
              selectItems={clinicsOrgItem}
              placeholder="Select Clinics"
              showTooltips={true}
              showTypedErrors={false}
              showDropdownIcon={true}
              defaultSelected={clinicsOrgItem?.filter((oc) => formHook.watch("clinics")?.includes(oc.id))}
              listBoxClassName="w-full"
              className="text-gray-800"
              containerClassName="w-full"
            />
          </div>
        </form>
      )}
    </div>
  );
};
export default DayClosingFilterComponent;
